import React from 'react';
import StaticPageLayout from '../components/StaticPageLayout';

const COPEPage = () => (
  <StaticPageLayout
    overline="Publication Ethics"
    title="Ethics Framework"
    description="MAH Quantum Research Institute's editorial and publication processes are structured in alignment with recognised global ethics standards for scholarly publishing."
    breadcrumbs={[{ label: 'Publication Ethics', path: '/publication-ethics' }, { label: 'Ethics Framework', path: '/cope-compliance' }]}
  >
    <div className="space-y-10">
      <div className="bg-blue-50 border border-blue-200 px-5 py-4">
        <p className="text-sm text-[#174EA6] leading-relaxed">
          This page describes the ethics principles that govern the platform's publication processes. These principles are aligned with — though not a formal endorsement by — the Committee on Publication Ethics (COPE) guidelines.
        </p>
      </div>

      <section>
        <h2 className="font-serif text-2xl font-semibold text-[#1F1F1F] mb-4 pb-3 border-b border-[#E5E7EB]">Core Ethical Principles</h2>
        <div className="space-y-3">
          {[
            { title: 'Integrity in Reporting', desc: 'All published research must accurately represent the methods, data, and findings of the original work. No selective reporting, misrepresentation, or manipulation of results is acceptable.' },
            { title: 'Transparent Peer Review', desc: 'The peer review process is conducted with confidentiality and impartiality. Reviewers are obligated to declare any conflicts of interest and recuse themselves where necessary.' },
            { title: 'Authorship Accountability', desc: 'All listed authors bear collective responsibility for the integrity of their submission. The corresponding author is responsible for ensuring that all co-authors have contributed meaningfully and approved the final version.' },
            { title: 'Conflict of Interest Disclosure', desc: 'All parties — authors, reviewers, and editors — are required to disclose any financial, professional, or personal relationships that could influence the objectivity of the publication process.' },
            { title: 'Post-Publication Responsibility', desc: 'Where errors are identified post-publication, corrections, expressions of concern, or retractions are issued transparently and promptly, with full documentation of the reason.' },
          ].map(item => (
            <div key={item.title} className="border border-[#E5E7EB] p-5 bg-white">
              <h3 className="font-semibold text-[#1F1F1F] text-sm mb-2">{item.title}</h3>
              <p className="text-sm text-[#6B7280] leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section>
        <h2 className="font-serif text-2xl font-semibold text-[#1F1F1F] mb-4 pb-3 border-b border-[#E5E7EB]">Reporting Ethics Concerns</h2>
        <p className="text-[#4B5563] leading-relaxed">
          Any individual with concerns about the integrity of a submission, a published article, or the conduct of any party involved in the publication process is encouraged to contact the editorial office at <span className="text-[#1A73E8]">info@mahquantum.tech</span>. All concerns are treated with strict confidentiality during investigation.
        </p>
      </section>
    </div>
  </StaticPageLayout>
);

export default COPEPage;
